import { createFileRoute } from '@tanstack/react-router'
import { LayoutCard } from '@/components/layouts/LayoutCard'
import { PrivacyContent } from '@/features/contact/components/PrivacyContent'

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <LayoutCard title="Privacy Policy">
      <PrivacyContent showContactButton={true} />
    </LayoutCard>
  )
}
